import dateHelper from "flow/utils/dateHelper";

function isNumChar(c: string): boolean {
    return c >= "0" && c <= "9";
}

function onlyConsistsOfDigits(str: string): boolean {
    return /^\d+$/.test(str);
}

function verifyCheckDigit(pid: string): boolean {
    const strArray = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "H",
        "J",
        "K",
        "L",
        "M",
        "N",
        "P",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y"
    ];

    const chArray = pid.split("");
    let num1 = 0;
    for (let i = 0; i < chArray.length; i++) {
        if (!isNumChar(chArray[i])) return false;
        ++num1;
        if (num1 > 5) break;
    }

    if (!isNumChar(chArray[7]) || !isNumChar(chArray[8]) || !isNumChar(chArray[9])) return false;

    const s = pid.substr(0, 6) + pid.substr(7, 3);
    if (!onlyConsistsOfDigits(s)) return false;

    const num2 = parseInt(s);
    const index = num2 % 31;
    return index <= 31 && !(pid.substr(10, 1) !== strArray[index]);
}

function isLetterOrDigit(str: string) {
    return str.length === 1 && str.match(/^[a-z0-9]+$/i);
}

function isValidDate(year: string, month: string, day: string): boolean {
    let isValid = true;
    let dateString = "";
    try {
        if (parseInt(year) > 1800) {
            // person can't have a birth year earlier than 1800
            dateString = year + "-" + month + "-" + day;
            isValid = dateHelper.isValidDateFormat(dateString);
        } else {
            isValid = false;
        }
    } catch (e) {
        isValid = false;
    }

    return isValid;
}

function validatePersonId(personId: string): boolean {
    if (!personId || personId.length !== 11) return false;

    const personSubstring = personId.substr(0, 6);
    for (let i = 0; i < personSubstring.length; i++) {
        if (!isNumChar(personSubstring[i])) {
            return false;
        }
    }

    switch (personId.substr(6, 1)) {
        case "A":
        case "B":
        case "C":
        case "D":
        case "E":
        case "F":
            if (!isValidDate("20" + personId.substr(4, 2), personId.substr(2, 2), personId.substr(0, 2))) return false;
            break;
        case "-":
        case "U":
        case "V":
        case "W":
        case "X":
        case "Y":
            if (!isValidDate("19" + personId.substr(4, 2), personId.substr(2, 2), personId.substr(0, 2))) return false;
            break;
        case "+":
            if (!isValidDate("18" + personId.substr(4, 2), personId.substr(2, 2), personId.substr(0, 2))) return false;
            break;
        default:
            return false;
    }

    const str = personId.substr(7, 4);
    if (
        (!isNumChar(str[0]) && str[0].charCodeAt(0) !== 84) ||
        (!isNumChar(str[1]) && str[1].charCodeAt(0) !== 80) ||
        !isNumChar(str[2]) ||
        !isLetterOrDigit(str[3])
    )
        return false;

    if (isNumChar(str[0]) || str[0].charCodeAt(0) !== 84 || isNumChar(str[1]) || str[1].charCodeAt(0) !== 80)
        return verifyCheckDigit(personId);

    return true;
}

function stripTransform(personId: string): string {
    return personId.trim().toUpperCase();
}

function doTransform(personId: string): string {
    return personId.toUpperCase();
}

export default {
    validatePersonId: validatePersonId,
    stripTransform: stripTransform,
    doTransform: doTransform
};
